<script setup>
import SelectBox from '@/components/shared/SelectBox.vue'
import TripSurveyQuestion from '@/components/shared/TripSurveyQuestion.vue'

const props = defineProps({
	trip: {
		type: Object,
		default: null,
	},
	survey: {
		type: Object,
		default: null,
	},
})

const emit = defineEmits(['change', 'open'])

const optionsOpened = (isOpen) => {
	emit('open', isOpen)
}

const optionSelected = (option) => {
	console.warn('optionSelected', option)

	if (option.code) props.survey.answerCode = option.code
	if (option.value) props.survey.answerValue = option.value

	// Set option as "selected" as true and set earlier options selected as false
	for (let i = 0; i < props.survey.options.length; i++) {
		props.survey.options[i].selected = false
		if (props.survey.options[i].code === option.code) {
			props.survey.options[i].selected = true
		}
	}

	// Emit event with the selected option and survey data
	emit('change', {
		trip: props.trip,
		survey: props.survey,
		selectedOption: option,
	})
}
</script>

<template>
	<div class="question" v-if="survey.options.length > 1">
		<div class="dot">?</div>
		<div class="title">
			<select-box class="form purposes" style="width: 100%; white-space: normal" :nowrap="false" :options="survey.options" v-model="survey.answer" @open="optionsOpened" @change="optionSelected">
				<template #selected-content>
					<label>{{ survey.question }}</label>
					<div class="name">{{ survey.answer.name }}</div>
				</template>
				<template #selected-none>
					<div class="name">{{ survey.question }}</div>
				</template>
				<template #item="item">
					{{ item.option.name }}
				</template>
			</select-box>
		</div>
	</div>
	<template v-if="survey.answer && survey.answer.sub">
		<TripSurveyQuestion :survey="survey.answer.sub" :trip="trip" @open="optionsOpened" @change="$emit('change', $event)" />
	</template>
	<template v-if="survey.answer && survey.answer.sub && survey.answer.sub.answer && survey.answer.sub.sub">
		<TripSurveyQuestion :survey="survey.answer.sub.sub" :trip="trip" @open="optionsOpened" @change="$emit('change', $event)" />
	</template>
</template>
